import { ProjectBranchConfigResponse } from '@/app/models/projectBranchConfig';
import { useListProjectBranchConfigsQuery } from '@/app/services/projectBranchConfigApi';
import { usePeriod } from '@/components/context/PeriodContext';
import PeriodDetails from '@/components/periodDetails/PeriodDetails';
import BranchResultCenterTable from '@/components/tables/BranchResultCenterTable';
import NewEditBranchResultCenterScreen from '@/components/uploadFiles/newEditScreen/NewEditBranchResultCenterScreen';
import { Box, Button, Drawer, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function BranchResultCenter() {
  const { t } = useTranslation(['branchResultCenter', 'common']);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(5);
  const [searchTerm] = useState('');

  const { selectedPeriod } = usePeriod();

  const { data } = useListProjectBranchConfigsQuery(
    {
      searchTerm: searchTerm.toUpperCase() as string,
      periodDate: selectedPeriod?.date as string,
      page,
      size,
    },
    { skip: !selectedPeriod },
  );

  const [drawerStatus, setDrawerStatus] = useState(false);
  const [selectedItem, setSelectedItem] = useState<ProjectBranchConfigResponse | null>(null);

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginRight: '1.25rem',
      }}
    >
      <PeriodDetails />
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Typography
            sx={{
              fontWeight: 'bold',
              fontSize: '18px',
              color: '#4b4b4b',
              marginTop: '2rem',
            }}
          >
            {t('common:branch.result.center')}
          </Typography>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
                pr: 3,
                marginTop: '3.125rem',
              }}
            >
              <Box display="flex" flexDirection="row">
                <Button
                  onClick={() => {
                    setSelectedItem(null);
                    setDrawerStatus(true);
                  }}
                  variant="text"
                  sx={{
                    color: '#f97c06',
                    textTransform: 'none',
                    fontWeight: 800,
                    fontSize: 14,
                  }}
                >
                  {` + ${t('add.branch')}`}
                </Button>
              </Box>
            </Box>
          </div>
        </Box>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '2.5rem',
          width: '100%',
        }}
      >
        <BranchResultCenterTable
          rows={data?.content || []}
          count={data?.totalElements as number}
          page={page}
          setPage={setPage}
          rowsPerPage={size}
          setRowsPerPage={setSize}
          setDrawerStatus={setDrawerStatus}
          setSelectedItem={setSelectedItem}
        />
      </div>
      <Drawer
        anchor="right"
        open={drawerStatus}
        onClose={() => {
          setDrawerStatus(false);
        }}
      >
        <NewEditBranchResultCenterScreen
          branchResultCenter={selectedItem}
          setDrawerOpen={setDrawerStatus}
        />
      </Drawer>
    </div>
  );
}
export default BranchResultCenter;
